<h4>Recommended Usage:</h4>
<div>
  In most cases the usage should be like this example taking care for Mobile first; If there is no mobile design to take into account still use uiXs instead of uiSpan as with uiSpan further mobile
  implementation is severely hindered
</div>
<div class="sp-mt-24">
  <div ui-row>
    <div ui-col [uiXs]="10">&lt;div ui-col [uiXs]="10"></div>
    <div ui-col [uiXs]="14">&lt;div ui-col [uiXs]="14"></div>
  </div>

  <div ui-row>
    <div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3">&lt;div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3"></div>
    <div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3">&lt;div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3"></div>
    <div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3">&lt;div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3"></div>
    <div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3">&lt;div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3"></div>
    <div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3">&lt;div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3"></div>
    <div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3">&lt;div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3"></div>
    <div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3">&lt;div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3"></div>
    <div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3">&lt;div ui-col [uiXs]="24" [uiSm]="12" [uiMd]="8" [uiLg]="6" [uiXl]="4" [uiXXl]="3"></div>
  </div>
</div>
<h4 class="sp-mt-32">Playground:</h4>
<div class="slider-container sp-mt-24">
  <span>Horizontal Gutter (px):</span>
  <div class="slider">
    <nz-slider [nzMarks]="marksHGutter" [nzStep]="null" [nzMin]="8" [nzMax]="48" [(ngModel)]="hGutter"></nz-slider>
  </div>
  <span>Vertical Gutter (px):</span>
  <div class="slider">
    <nz-slider [nzMarks]="marksVGutter" [nzStep]="null" [nzMin]="8" [nzMax]="48" [(ngModel)]="vGutter"></nz-slider>
  </div>
  <span>Column Count:</span>
  <div class="slider">
    <nz-slider [nzMarks]="marksCount" [nzStep]="null" [nzMin]="2" [nzMax]="12" [(ngModel)]="count" (ngModelChange)="reGenerateArray($event)"></nz-slider>
  </div>
</div>

<div class="gutter-example">
  <div ui-row [uiGutter]="[hGutter, vGutter]">
    <div ui-col class="gutter-row" [uiSpan]="24 / count" *ngFor="let i of array">
      <div class="grid-config">Column</div>
    </div>
    <div ui-col class="gutter-row" [uiSpan]="24 / count" *ngFor="let i of array">
      <div class="grid-config">Column</div>
    </div>
  </div>
</div>

<h4 class="sp-mt-32">Responsive:</h4>
<div class="sp-mt-24">
  <p>Percentage columns</p>
  <div ui-row class="responsive-row">
    <div ui-col uiFlex="2">2 / 5</div>
    <div ui-col uiFlex="3">3 / 5</div>
  </div>
  <p>Fill rest</p>
  <div ui-row>
    <div ui-col uiFlex="100px">100px</div>
    <div ui-col uiFlex="auto">Fill Rest</div>
  </div>
  <p>Raw flex style</p>
  <div ui-row>
    <div ui-col uiFlex="1 1 200px">1 1 200px</div>
    <div ui-col uiFlex="0 1 300px">0 1 300px</div>
  </div>
</div>
